import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.connector-section.title',
		defaultMessage: 'Select a source code management tool',
		description: 'The title of the connector section',
	},
	subtitle: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.connector-section.subtitle',
		defaultMessage: 'Get started free',
		description: 'The sub title of the connector section',
	},
	connectToBitbucketButtonLabel: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.connector-section.connect-to-bitbucket-button-label',
		defaultMessage: 'Connect to Bitbucket',
		description: 'Label for the primary Bitbucket button',
	},
	connectToOtherProvidersButtonLabel: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.connector-section.connect-to-other-providers-button-label',
		defaultMessage: 'Connect to other providers',
		description: 'Label for the primary secondary other providers button',
	},
});
